<!-- OTP Form -->
<div>
  <h4 class="!text-2xl font-bold text-black mb-2">Verify OTP</h4>
  <p class="text-sm text-gray-600 mb-5">OTP sent to {{ username }}</p>
  <form [formGroup]="otpFormGroup" (submit)="verifyOtp()" class="space-y-4">
    <div>
      <p-input-otp
        size="large"
        [length]="6"
        [integerOnly]="true"
        (keydown.enter)="verifyOtp()"
        styleClass="w-[50px] h-[50px]"
        formControlName="otp"
      ></p-input-otp>
    </div>
    @if (errorMessage) {
      <div class="text-red-600 text-sm font-medium">
        {{ errorMessage }}
      </div>
    }

    @if (otpSent) {
      <div class="text-green-600 text-sm text-center">
        {{ infoMessage }}
      </div>
    }

    <div>
      <p-button styleClass="w-[41%]" class="w-full" label="Verify OTP" (onClick)="verifyOtp()" [disabled]="otpLoader">
      </p-button>
    </div>

    <!-- Resend Section -->
    @if (!resendLimitExceeded) {
      <div class="flex justify-center items-center ">
        @if (isResendDisabled) {
          <div class="text-xs text-gray-500">
            You can resend OTP in {{ timer }} seconds
          </div>
        }
        <p-button
          [outlined]="false"
          class="font-bold "
          styleClass="bg-white text-gray-900 border-0 cursor-p"
          (onClick)="resendOtp()"
          label="Resend OTP"
        >
        </p-button>
      </div>
    }

  </form>
</div>


